const { initAccordions } = require("./accordions");
const { initMegaMenu } = require("./megamenu");
const { initMenu } = require("./menu");
const { default: initProductFiltersForm } = require("./product-filters");
const { initProductRecommendations } = require("./product-recommendations");
const { initSearchBar } = require("./search-bar");
const { initSliders } = require("./sliders");
const { initTabs } = require("./tabs");
const { tabTableinit } = require("./tabTable");
const { initCopyLink } = require("./copy-link");
const { initPageOverlays } = require("./page-overlay");
const { initTabsFaqs } = require("./tabs-faqs");


document.addEventListener("DOMContentLoaded", function () {
    AOS.init({
        startEvent: 'load',
        disableMutationObserver: false,
      });
    AOS.refresh(true); 
    initSliders()
    initAccordions()
    initTabs()
    initMenu()
    initMegaMenu()
    initSearchBar()
    initProductFiltersForm()
    tabTableinit()
    initCopyLink()
    initProductRecommendations()
    initPageOverlays()
    initTabsFaqs()
})